
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class CasaAccountService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'casaaccount/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  getAll(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'casaaccount').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  get(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'casaaccount/customer').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `casaaccount/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  create(casaAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'casaaccount', casaAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  update(casaAccount: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'casaaccount', casaAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(casaAccount: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'casaaccount/authorise', casaAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `casaaccount/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  // getCasaAccountByCustomerId(customerId: number): Observable<any> {
  //   return this.httpClient.get(this.baseApiUrl + `casaaccount/casa/${customerId}`).pipe(
  //     map((res: Response) =>res),
  //     catchError((err: any) => observableThrowError(err.message || 'Server error')));
  // }
  getByCustomerId(id: number,generalLedgerId:number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `casaaccount/get/${id}?generalLedgerId=${generalLedgerId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  CheckForDuplicateCustomerId(customerId: number,schemeId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `casaaccount/duplicate/${customerId}?schemeId=${schemeId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateAccountStatus(customerAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'casaaccount/updateaccountstatus', customerAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
 
  calculateInterestAmount(accountId: number,generalLedgerId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `casaaccount/calculateinterestamount?accountId=${accountId}&&generalLedgerId=${generalLedgerId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  saveInterestPayment(customerAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'casaaccount/saveinterestpayment', customerAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
    getAllCasaAccountsByCustomerId(customerId: number): Observable<any> {
    return this.httpClient.get(
      this.baseApiUrl + `casaaccount/getallbycustomer/${customerId}`
    ).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  
}
